module.exports = __webpack_public_path__ + "img/logo1.56ae888d.jpg";